"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROGRESS_STEPPER_APPEARANCES = void 0;
var PROGRESS_STEPPER_APPEARANCES = Object.freeze({
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  WARNING: 'warning',
  ERROR: 'error',
  NONE: 'none'
});
exports.PROGRESS_STEPPER_APPEARANCES = PROGRESS_STEPPER_APPEARANCES;